import { logger } from '@jurnee/common/src/browser/Logger';
import { PartnerJSON } from '@jurnee/common/src/entities/Partner';
import { PartnerJwt, parseJwt } from '@jurnee/common/src/utils/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPartner } from 'api/partner';
import { RootState } from 'store';
import { logout } from 'store/auth/auth.store';
import { getPartnerStatsThunk } from 'store/partnerStats/partnerStats.thunks';

export const bootstrap = createAsyncThunk<{ partner: PartnerJSON }, void, { state: RootState }>('BOOTSTRAP', async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    if (!state.auth.token) {
      throw new Error('No auth token available');
    }

    const jwt = parseJwt<PartnerJwt>(state.auth.token);
    const partner = state.partner.data ?? await getPartner(jwt.partnerId);
    const userId = jwt.type === 'PARTNER_USER_ACCESS_TOKEN' ? jwt.partnerUserId : String(jwt.partnerId);

    logger.setContext({ userId, partnerId: partner.id });

    thunkAPI.dispatch(getPartnerStatsThunk(partner.id));

    logger.info('Bootstrapping succeeded');

    return { partner };
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    logger.error('Bootstrapping failed', { error: message });
    thunkAPI.dispatch(logout());
    return thunkAPI.rejectWithValue({ partner: null });
  }
});